import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-console */
import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { P, useIovation } from 'shared';
import { PreparingOfferModal } from '../../../../credit_application/components';
import { useEDSPreventBacktracking } from '../_hooks';
import useAddtionalInfoEDS from '../_hooks/useAdditionalInfoEDS';
import { useEDSStore } from '../_store/eds.store';
import { getIntroSlug, getOfferSlug } from '../_utils/getSlugs';
import DisabledEDS from '../DisabledEDS';
import AdditionalInfoFormEDS from './AdditionalInfoFormEDS';
function AdditionalInfoEDS() {
    // State
    const [isOpen, setIsOpen] = useState(false);
    // Hooks
    const history = useHistory();
    const [getBlackboxData] = useIovation();
    useEDSPreventBacktracking({ currentPage: 'AdditionalInfoEDS' });
    // API
    const { postNextLender, patchCreditApplication } = useAddtionalInfoEDS();
    // Store
    const { edsEnabled, edsApplicant } = useEDSStore();
    // Has Credit Application
    const creditApplicationId = edsApplicant?.creditApplication?.applicationId;
    // Blackbox data
    const blackboxData = getBlackboxData();
    // Funcs
    const handleSubmitCallback = async (data) => {
        if (creditApplicationId) {
            const patchObject = {
                applicationId: creditApplicationId,
                patchConsumerApplicationsV2CreditApplicationsApplicationId: {
                    annualIncome: Number(data.annualIncome),
                    incomeFrequency: data.paymentFrequency,
                    primaryIncomeSource: data.primaryIncomeSource,
                },
            };
            const resp1 = await patchCreditApplication(patchObject);
            if ('data' in resp1) {
                useEDSStore.setState({
                    edsPersonalInfo: {
                        ...resp1.data,
                    },
                });
            }
            else {
                console.error('Error in resp1:', resp1.error);
            }
            setIsOpen(true);
            const resp2 = await postNextLender({
                applicationId: creditApplicationId,
                postConsumerApplicationsV2PrequalificationsApplicationIdNextLender: {
                    iovationBlackBox: blackboxData.blackbox,
                },
            });
            if (resp2) {
                if ('data' in resp2) {
                    useEDSStore.setState({
                        edsOffer: {
                            ...resp2.data,
                        },
                    });
                    history.push(getOfferSlug());
                }
                else {
                    console.error('Error in resp2:', resp2.error);
                }
            }
        }
    };
    return (_jsxs("div", { className: "container max-width-800 min-height-600 mar-auto", children: [edsEnabled && (_jsx("div", { className: "mar-b-40", children: _jsx(AdditionalInfoFormEDS, { handleSubmit: handleSubmitCallback }) })), (edsEnabled === null || !creditApplicationId) && (_jsx("div", { className: "max-width-600 mar-auto text-center", children: _jsxs(P, { children: ["Please re-start the application", ' ', _jsx(Link, { to: getIntroSlug(), children: "here" }), "."] }) })), edsEnabled === false && _jsx(DisabledEDS, {}), _jsx(PreparingOfferModal, { isOpen: isOpen, setIsOpen: setIsOpen })] }));
}
export default AdditionalInfoEDS;
